export var PolygonMaskMoveType;
(function (PolygonMaskMoveType) {
    PolygonMaskMoveType["path"] = "path";
    PolygonMaskMoveType["radius"] = "radius";
})(PolygonMaskMoveType || (PolygonMaskMoveType = {}));
